document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".timeline-history .year-button");
  const contents = document.querySelectorAll(".timeline-history .timeline-content");

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const year = btn.dataset.year;

      // Toggle button states
      buttons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      // Toggle content visibility
      contents.forEach((content) => {
        content.classList.toggle("active", content.dataset.year === year);
      });
    });
  });
});